exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".require-label {\r\n    color: red;\r\n    font-size: 11px;\r\n    font-weight: 500;\r\n    font-style: italic;\r\n}\r\n\r\n.error span {\r\n    color: red;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/shared/common-modal/user-change-pwd-modal/user-change-pwd-modal.component.css
// module id = ../../../../../src/app/shared/common-modal/user-change-pwd-modal/user-change-pwd-modal.component.css
// module chunks = main